<template>
    <div class="page">
        <Menu/>
        <div class="registerContent">
            <div class="form-box">
                <div class="img-box">
                    <img class="img" src="/img/login_bg.png" alt="">
                </div>
                <div class="form">
                    <div class="title">欢迎注册</div>
                    <div class="item">
                        <span class="iconfont icon-wo"></span>
                        <input type="text" maxlength="20" v-model="nickname" placeholder="请输入姓名"/>
                    </div>
                    <div class="item">
                        <span class="iconfont icon-android"></span>
                        <input type="text" maxlength="11" v-model="mobile" placeholder="请输入您的电话号码"/>
                    </div>
                    <div class="item">
                        <span class="iconfont icon-mima"></span>
                        <input type="password" maxlength="16" v-model="password" placeholder="请输入您的密码"/>
                    </div>
                    <div class="item validateCode">
                        <input type="text" @keyup.enter="registerFun" v-model="validateCode" maxlength="6" minlength="1" placeholder="请输入您的验证码"/>
                        <!--输入框-->
                        <button class="sendValdateCode" :disabled="!canClick" @click="sendSmsCode">
                            {{validateCodeText}}
                        </button>
                    </div>
                    <div class="agreement">
                        <input type="checkbox" v-model="checked" @change="checkedFun" id="chkAgree"><label
                        for="chkAgree">我已阅读并同意</label> <a class="agreement_page" href="#">《祈山志远健康培训认证会员规则》</a>
                    </div>
                    <div class="register_button" @click="registerFun">
                        马上注册
                    </div>
                    <div class="go_login">
                        <div>
                            已有帐号？请直接 <a @click="$router.push(`/login`)" href="javascript:void(0)">登录</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Menu from '@/components/Menu2.vue'
    import Footer from '@/components/Footer.vue'
    import {register, smgRegCode} from '@/api/account.js'


    export default {
        data() {
            return {

                canClick:true,
                checked: 1,//规则
                validateCodeText: "获取验证码",//验证码文本框
                timer: 0,//定时器

                nickname: '',
                mobile: '',
                password: '',
                validateCode: '',


            }
        },
        components: {
            Menu,
            Footer
        },
        methods: {
            sendSmsCode: function () {
                if (!this.mobile) {
                    this.$message({
                        message: '电话号码不能为空',
                        type: 'warning'
                    });
                    return;
                }

                smgRegCode(this.mobile).then(resp => {
                    if (resp!=-1){
                        this.timer=resp;
                        this.countDown();
                    }
                });
            },


            countDown() {
                if (!this.canClick) return;
                this.canClick = false;
                this.validateCodeText = this.timer + 's后重新发送';
                let clock = window.setInterval(() => {
                    this.timer--;
                    this.validateCodeText = this.timer + 's后重新发送';
                    if (this.timer < 0) {
                        window.clearInterval(clock);
                        this.validateCodeText = '重新发送';
                        this.timer = 10;
                        this.canClick = true  //这里重新开启
                    }
                }, 1000)
            },

            checkedFun: function () {
                this.checked = !this.checked;
            },
            registerFun: function () {
                if (!this.nickname) {
                    this.$message({
                        message: '昵称不能为空',
                        type: 'warning'
                    });
                    return;
                }
                if (!this.mobile) {
                    this.$message({
                        message: '电话号码不能为空',
                        type: 'warning'
                    });
                    return;
                }
                if (!this.password) {
                    this.$message({
                        message: '密码不能为空',
                        type: 'warning'
                    });
                    return;
                }
                if (!this.validateCode) {
                    this.$message({
                        message: '验证码不能为空',
                        type: 'warning'
                    });
                    return;
                }
                if (!this.checked) {
                    this.$message({
                        message: '必须同意《祈山志远健康培训认证会员规则》!',
                        type: 'warning'
                    });
                    return;
                }
                const loading = this.$loading({
                    lock: true,
                    text: '登录中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var jxjy_org_id = this.$route.params.jxjy_org_id == undefined ? 0 : this.$route.params.jxjy_org_id;
                register(this.mobile, this.nickname, this.validateCode, this.password, document.referrer, jxjy_org_id).then(resp => {
                    loading.close();
                    if (resp != -1) {
                        this.$message({
                            showClose: true,
                            message: resp,
                            type: 'success'
                        });
                        setTimeout(() => {
                            this.$router.push(`/login`)
                        }, 1500);
                    }
                });
            }

        }
    }
</script>
<style lang="scss" scoped>
    body {
        background: #efefef;
    }

    .registerContent {
        background: #efefef url('/img/login_bg2.png') no-repeat center center;
        margin: 0 auto;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;

        .form-box {
            background: white;
            width: 1000px;
            margin: 60px auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .img-box {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-content: center;

                .img {
                    width: 400px;
                    background: #efefef;
                    display: block;
                    margin: 0 auto;
                }
            }

            .form {
                padding: 20px;
                margin: 40px 30px;

                .title {
                    text-align: center;
                    color: #313131;
                    font-weight: bold;
                    font-size: 1.8em;
                }

                .item {
                    margin: 12px 0;
                    border: 1px solid #bebebe;

                    span {
                        margin-left: 10px;
                        color: #313131;
                    }

                    input {
                        width: 300px;
                        border: 0;
                        outline: none;;;
                        height: 40px;
                        line-height: 40px;
                        padding: 0 10px;
                        color: #101010;
                    }
                }

                .validateCode {
                    position: relative;

                    .sendValdateCode {
                        border: none;
                        cursor: pointer;
                        background: #313131;
                        width: 100px;
                        position: absolute;
                        top: 0;
                        right: 0;
                        height: 41px;
                        line-height: 41px;
                        color: white;
                        text-align: center;
                    }
                }

                .agreement {
                    label {
                        color: #767676;
                        font-weight: 1.4em;
                    }

                    .agreement_page {
                        color: #5d9bf9;
                        font-size: 1.4em;
                        text-decoration: underline;
                    }
                }

                .register_button {
                    cursor: pointer;
                    font-weight: bold;
                    font-size: 1.6em;
                    color: white;
                    background: #313131;
                    padding: 10px;
                    text-align: center;
                    margin-top: 30px;
                }

                .go_login {
                    margin: 15px 0;
                    font-size: 1.4em;
                    color: #b8b8b8;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;

                    a {
                        color: #313131;
                    }
                }
            }
        }

        //重置底部margin-top;

    }

    .footer-box {
        margin-top: 0;
    }

</style>
